import React from 'react'
import { IconTypeProps } from '../icon';

export function IconCalendar({
  onClick = () => {},
  className = '',
  ...rest
}: IconTypeProps) {
  return (
    <svg
      className={className}
      onClick={onClick}
      viewBox='0 0 38 38'
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M34.0412 6.33337H30.6106V8.44449H33.7773V31.6667H4.22173V8.44449H7.3884V6.33337H3.95785C3.7111 6.3375 3.46758 6.39019 3.24119 6.48844C3.01481 6.5867 2.81 6.72858 2.63847 6.906C2.46693 7.08342 2.33202 7.29289 2.24145 7.52246C2.15089 7.75202 2.10643 7.99718 2.11062 8.24393V31.8673C2.10643 32.114 2.15089 32.3592 2.24145 32.5887C2.33202 32.8183 2.46693 33.0278 2.63847 33.2052C2.81 33.3826 3.01481 33.5245 3.24119 33.6227C3.46758 33.721 3.7111 33.7737 3.95785 33.7778H34.0412C34.2879 33.7737 34.5314 33.721 34.7578 33.6227C34.9842 33.5245 35.189 33.3826 35.3606 33.2052C35.5321 33.0278 35.667 32.8183 35.7576 32.5887C35.8481 32.3592 35.8926 32.114 35.8884 31.8673V8.24393C35.8926 7.99718 35.8481 7.75202 35.7576 7.52246C35.667 7.29289 35.5321 7.08342 35.3606 6.906C35.189 6.72858 34.9842 6.5867 34.7578 6.48844C34.5314 6.39019 34.2879 6.3375 34.0412 6.33337Z"/>
      <path d="M8.44434 14.7778H10.5554V16.8889H8.44434V14.7778Z"/>
      <path d="M14.7773 14.7778H16.8885V16.8889H14.7773V14.7778Z"/>
      <path d="M21.1113 14.7778H23.2224V16.8889H21.1113V14.7778Z"/>
      <path d="M27.4443 14.7778H29.5554V16.8889H27.4443V14.7778Z"/>
      <path d="M8.44434 20.0555H10.5554V22.1667H8.44434V20.0555Z"/>
      <path d="M14.7773 20.0555H16.8885V22.1667H14.7773V20.0555Z"/>
      <path d="M21.1113 20.0555H23.2224V22.1667H21.1113V20.0555Z"/>
      <path d="M27.4443 20.0555H29.5554V22.1667H27.4443V20.0555Z"/>
      <path d="M8.44434 25.3334H10.5554V27.4445H8.44434V25.3334Z"/>
      <path d="M14.7773 25.3334H16.8885V27.4445H14.7773V25.3334Z"/>
      <path d="M21.1113 25.3334H23.2224V27.4445H21.1113V25.3334Z"/>
      <path d="M27.4443 25.3334H29.5554V27.4445H27.4443V25.3334Z"/>
      <path d="M10.5556 10.5555C10.8355 10.5555 11.104 10.4443 11.3019 10.2464C11.4999 10.0484 11.6111 9.77992 11.6111 9.49997V3.16664C11.6111 2.88669 11.4999 2.6182 11.3019 2.42025C11.104 2.22229 10.8355 2.11108 10.5556 2.11108C10.2756 2.11108 10.0071 2.22229 9.80917 2.42025C9.61121 2.6182 9.5 2.88669 9.5 3.16664V9.49997C9.5 9.77992 9.61121 10.0484 9.80917 10.2464C10.0071 10.4443 10.2756 10.5555 10.5556 10.5555Z"/>
      <path d="M27.4442 10.5555C27.7242 10.5555 27.9927 10.4443 28.1906 10.2464C28.3886 10.0484 28.4998 9.77992 28.4998 9.49997V3.16664C28.4998 2.88669 28.3886 2.6182 28.1906 2.42025C27.9927 2.22229 27.7242 2.11108 27.4442 2.11108C27.1643 2.11108 26.8958 2.22229 26.6978 2.42025C26.4999 2.6182 26.3887 2.88669 26.3887 3.16664V9.49997C26.3887 9.77992 26.4999 10.0484 26.6978 10.2464C26.8958 10.4443 27.1643 10.5555 27.4442 10.5555Z"/>
      <path d="M13.7227 6.33337H24.2782V8.44449H13.7227V6.33337Z"/>
    </svg>
  );
}

